import React from "react";

const AdminHeader = ({ userName = "Admin User" }) => {
  const handleLogout = () => {
    localStorage.removeItem("jwtToken");
    window.location.href = "/";
  };

  return (
    <header className="bg-gray-800 text-white px-6 py-4 flex justify-between items-center h-16 shadow-lg">
      <div className="flex items-center gap-3">
        <span className="text-2xl">📊</span>
        <h1 className="text-xl font-bold">DVSA Admin</h1>
      </div>
      <div className="flex items-center gap-4">
        <span className="text-sm text-gray-300">{userName}</span>
        <button
          onClick={handleLogout}
          className="px-3 py-1 bg-gray-700 hover:bg-gray-600 rounded text-sm transition-colors"
        >
          Logout
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;
